export default __webpack_public_path__ + "static/media/password.642966a8.svg";